// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__15s76","colMaxWidth":"Table_colMaxWidth__1DrZs"};